import AmbryItem from "./AmbryItem";
import O1HD from "../../../engines/gameEngine";
import LotteryGGLPrefab from "./gglLottery/LotteryGGLPrefab";
import LotteryFFCManager from "./ffcLottery/LotteryFFCManager";
import LotteryFFCSimplePrefab from "./ffcSimple/LotteryFFCSimplePrefab";
import gameConfig from "../../../engines/configs/gameConfig";
import LotteryCenterV2Prefab from "./gglLottery/v2/LotteryCenterV2Prefab";
import normalMode from "../normalMode";
import LotteryMachine from "./LotteryMachine/LotteryMachine";

const {ccclass, property} = cc._decorator;

/**
 * 彩票中心
 */
@ccclass
export default class LotteryCenterPrefab extends cc.Component {

    @property(cc.Prefab)
    ambryItemPrefab : cc.Prefab = null;
    @property(cc.Node)
    ambryContentNode : cc.Node = null;

    @property({type:cc.Prefab,displayName:"刮刮乐预制体"})
    lotteryGGLV2Prefab : cc.Prefab = null;
    @property({type:cc.Prefab,displayName:"分分彩预制体"})
    lotteryFFCPrefab : cc.Prefab = null;
    @property({type:cc.Prefab,displayName:"双色球预制体"})
    ssqPrefab : cc.Prefab = null;


    private mLotteryFFCManager : LotteryFFCManager;
    private readonly ChineseZodiacArray : string[] = ['鼠','牛','虎','兔','龙','蛇','马','羊','猴','鸡','狗','猪'];
    private mParentScript : normalMode;

    // private prizeArray :  ;

    onLoad () {}

    start () {
        this.initData();
        O1HD.getManagers().soundMgr.playSound("caipiaodianlaoban");
    }

    bindData( lotteryFFCManager : LotteryFFCManager ,mParentScript : normalMode){
        this.mLotteryFFCManager = lotteryFFCManager;
        this.mParentScript = mParentScript;
    }

    /**
     * 初始化 橱柜
     */
    initData(){
        // for ( let chineseZodiac of this.ChineseZodiacArray ) {
        //     // 初始化橱柜
        //     let ambryItemNode = cc.instantiate( this.ambryItemPrefab );
        //     ambryItemNode.getComponent( AmbryItem ).bindData( chineseZodiac );
        //     this.ambryContentNode.addChild( ambryItemNode );
        // }
    }

    /**
     * 退出
     */
    onBtnExit(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.node.removeFromParent();
        this.node.destroy();
    }


    /**
     * 打开刮刮乐
     */
    onBtnOpenGGLottery( e , gglCount : string ){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let gglPrefabNode = cc.instantiate( this.lotteryGGLV2Prefab );
        this.node.addChild( gglPrefabNode );
        gglPrefabNode.getComponent( LotteryCenterV2Prefab ).bindData(this.mParentScript );
    }

    /**
     * 双色球
     * @param e
     * @param gglCount
     */
    onBtnOpenSSQ( e , gglCount : string ){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let ssqPrefabNode = cc.instantiate( this.ssqPrefab );
        this.node.addChild( ssqPrefabNode );
        // ssqPrefabNode.getComponent( LotteryMachine ).bindData(this.mParentScript );
    }

    /**
     * 暂未开放
     * @param e
     * @param gglCount
     */
    onBtnOpenZwkf( e , gglCount : string ){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        O1HD.getModules().uiControlModule.showMessageBox("暂未开放",this.node );
    }

    /**
     * 打开分分彩预制体
     * @param e
     */
    onBtnOpenFFCLottery( e ){
        // if ( O1HD.getServices().userSrv.getCoins() < gameConfig.LOTTERY_FFC_BET_COINS ) {
        //     O1HD.getModules().uiControlModule.showMessageBox("金币不足",this.node);
        //     return;
        // }
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if ( this.mLotteryFFCManager.currBetLotteryNumber.length > 0 ) {
            O1HD.getModules().uiControlModule.showMessageBox("一天只能购买一注哦",this.node);
            return;
        }
        let ffcPrefabNode = cc.instantiate( this.lotteryFFCPrefab );
        this.node.addChild( ffcPrefabNode );
        this.node.getChildByName("btnNode").active = false;
        ffcPrefabNode.getComponent( LotteryFFCSimplePrefab ).bindData( this.mLotteryFFCManager );
    }
}
